"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtistAPI = void 0;
var api_utils_1 = require("../../utils/api.utils");
var api_client_1 = __importDefault(require("../../api/api-client"));
var artist_constants_1 = require("./artist.constants");
var ArtistAPI = /** @class */ (function () {
    function ArtistAPI() {
    }
    ArtistAPI.addToUniverse = function (data) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_ADD_TO_UNIVERSE, data);
    };
    ArtistAPI.create = function (data) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_CREATE, data);
    };
    ArtistAPI.update = function (data) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_UPDATE, data);
    };
    ArtistAPI.updateAvatar = function (artistId, data) {
        return api_client_1.default.post((0, api_utils_1.replaceUrlParams)(artist_constants_1.ARTIST_API_URLS.ARTIST_UPDATE_AVATAR, {
            id: artistId
        }), data);
    };
    ArtistAPI.deleteAvatar = function (id) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_DELETE_AVATAR, { id: id });
    };
    ArtistAPI.removeBanner = function (id) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.CREATOR_REMOVE_BANNER, { id: id });
    };
    ArtistAPI.delete = function (data) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_DELETE, data);
    };
    ArtistAPI.removeFromUniverse = function (data) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_REMOVE_FROM_UNIVERSE, data);
    };
    ArtistAPI.fetchCountries = function () {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_COUNTRIES, {});
    };
    // deprecated use fetchByFilter
    ArtistAPI.fetchAll = function () {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTISTS_FETCH, {});
    };
    // deprecated use fetchByFilter
    ArtistAPI.fetchMy = function () {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTISTS_FETCH_MY, {});
    };
    ArtistAPI.fetchById = function (id) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTISTS_FETCH_ONE, { id: id });
    };
    // deprecated use fetchByFilter
    ArtistAPI.fetchByUniverse = function (universeId) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_GET_BY_UNIVERSE, { id: universeId });
    };
    ArtistAPI.fetchHighlights = function (data) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_FETCH_HIGHLIGHTS, data);
    };
    ArtistAPI.searchArtistKeywords = function (keywords) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_SEARCH, { keywords: keywords });
    };
    ArtistAPI.fetchByFilter = function (data) {
        return api_client_1.default.post(artist_constants_1.ARTIST_API_URLS.ARTIST_GET_BY_FILTER, data);
    };
    return ArtistAPI;
}());
exports.ArtistAPI = ArtistAPI;
